"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.money = void 0;
var money_1 = require("../utils/money");
function money(value, locale) {
    var amount = typeof value === 'number' ? value : (0, money_1.dollars)(value);
    var currency = typeof value === 'number' ? 'USD' : value.currencyCode;
    return amount.toLocaleString(locale, { style: 'currency', currency: currency });
}
exports.money = money;
exports.default = {
    money: money,
};
//# sourceMappingURL=format.js.map